import { ApiFailure } from "../../restClient";
import {
  WithdrawalFormValues,
  WithdrawalPreview,
  WithdrawalReceipt,
} from "./withdrawalApi";

/**
 * What the two withdrawal routes hand each other through the router state. The
 * form lives on WITHDRAWAL_PATH, the "Widerruf bestätigen" button on
 * WITHDRAWAL_CONFIRM_PATH, and nothing of it is kept anywhere else: a name and
 * an address have no business in local storage.
 */
export interface WithdrawalNavState {
  /** What was typed, so "Angaben ändern" comes back to a filled form. */
  values?: WithdrawalFormValues;
  /** Opens the form straight away instead of behind the button. */
  openForm?: boolean;
  /** The confirmation page, as the backend built it. */
  preview?: WithdrawalPreview;
  /** Fields the backend rejected after the person had left the form. */
  fieldErrors?: (keyof WithdrawalFormValues)[];
  /** The failure that sent the person back to the form. */
  failure?: ApiFailure;
  /**
   * Set once the withdrawal is received. ⚠️ Kept in the history entry on
   * purpose: a reload then shows the receipt again instead of the button, so
   * the declaration cannot be sent twice by accident.
   */
  receipt?: WithdrawalReceipt;
}

export const EMPTY_FORM: WithdrawalFormValues = {
  name: "",
  email: "",
  contractReference: "",
  note: "",
};

/** Reads the router state, which is `unknown` to react-router. */
export const readNavState = (state: unknown): WithdrawalNavState =>
  state && typeof state === "object" ? (state as WithdrawalNavState) : {};
